export const TargetingLocationType = {
    Country: "Country",
    City: "City",
    State: "State",
    Region: "Region",
} as const;
